import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AdminSettingsService } from '../../../../Services/Admin_Settings/admin-settings.service';
import { NotificationService } from '../../../../Services/notification.service';
import { FormsModule } from '@angular/forms';
import { CustomizeService } from '../../../../Services/Customize_settings/customize.service';
import { FirmSelectionService } from '../../../../Services/firm-selection.service'; // Import this

@Component({
  selector: 'app-set-type',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './set-type.component.html',
  styleUrls: ['./set-type.component.css']
})
export class SetTypeComponent implements OnInit {

  loginType: 'main' | 'simple' = 'simple';
  sellType: 'manual' | 'auto' = 'manual';

  logoPreview: string | ArrayBuffer | null = null;
  selectedFile: File | null = null;
  selectedFirmId!: number;
  settingId: any = null; // Stores the ID for updates
  logoImage: any;

  constructor(
    private adminSettingsService: AdminSettingsService,
    private notificationService: NotificationService,
    private customizeService: CustomizeService,
    private firmSelectionService: FirmSelectionService // Inject Firm Service
  ) { this.getCustomizeLogo() }

  ngOnInit(): void {
    // 1. Load Admin Settings (Login/Sell Types)
    this.adminSettingsService.getAdminSettings().subscribe((res: any) => {
      if (res.data && res.data[0]) {
        const data = res.data[0];
        this.loginType = data.login_type;
        this.sellType = data.sell_type;
      }
    });

    // 2. Load Customize Settings based on Selected Firm (Same pattern as Dropdown component)
    this.firmSelectionService.selectedFirmName$.subscribe((firm: any) => {
      if (firm?.id) {
        this.selectedFirmId = firm.id;
        this.loadCustomizeSettings();
      }
    });
  }

  loadCustomizeSettings(): void {
    if (!this.selectedFirmId) return;

    // Use the same getUserSettings method from your dropdown component
    this.customizeService.getUserSettings(this.selectedFirmId).subscribe({
      next: (response) => {
        const settings = response.data;
        if (settings) {
          this.settingId = settings.id; // Capture ID for the update call
          // If logo exists in DB, load it into preview
          if (settings.logo) {
            this.logoPreview = settings.logo;
          }
        }
      },
      error: (err) => {
        console.error('Failed to load customize settings', err);
      }
    });
  }

  saveLoginAndSellType() {
    this.adminSettingsService.createAdminSettings({
      login_type: this.loginType,
      sell_type: this.sellType
    }).subscribe({
      next: () => {
        this.notificationService.showSuccess('Settings saved successfully!', 'Success');
      },
      error: (err) => {
        this.notificationService.showError('Failed to save settings.', 'Error');
      }
    });
  }

  onLogoSelected(event: any): void {
    const file = event.target.files[0];
    if (file) {
      this.selectedFile = file;
      const reader = new FileReader();
      reader.onload = () => {
        this.logoPreview = reader.result;
      };
      reader.readAsDataURL(file);
    }
  }

  uploadLogo(): void {
    if (!this.selectedFile) return;

    const formData = new FormData();
    // Use the key your backend expects (e.g., 'logo' or 'logo_path')
    formData.append('logo', this.selectedFile);
    formData.append('customize_firm_id', this.selectedFirmId.toString());

    // If settingId exists, we update. Otherwise, you might need a 'create' method.
    // Based on your previous error, updateCustomizeSetting needs (id, data)
    this.customizeService.saveUserSettings(formData).subscribe({
      next: (res: any) => {
        this.notificationService.showSuccess("Logo updated successfully", "Success");
        this.selectedFile = null;

        const logoUrl = res.data?.logo_url;

        if (logoUrl) {
          const finalUrl = logoUrl + '?v=' + new Date().getTime();
          this.logoPreview = finalUrl;

          // 🔥 PUSH TO ENTIRE APP
          this.customizeService.setLogo(finalUrl);
        }
      },
      error: (err) => {
        console.error("Upload error", err);
        this.notificationService.showError("Failed to upload logo", "Error");
      }
    });
  }

  getCustomizeLogo() {
    this.customizeService.getCustomizeSettings().subscribe((res: any) => {
      console.log("Customize settings data", res.data);
      const logoUrl = res.data[0]?.logo_url;

      if (logoUrl) {
        const finalUrl = logoUrl + '?v=' + new Date().getTime(); // 🔥 cache buster

        this.logoImage = finalUrl;
        this.logoPreview = finalUrl;
      }
    })
  }
}